import React from 'react'
import { Layout } from 'antd';
import { useLocation } from "react-router-dom";


function Footer() {

    const pathname = useLocation().pathname;
    const pathnameSplitArray = pathname.split("/")

    return (
        <>
        {
            (pathnameSplitArray[1] !== 'embedded-report-summary'
            && pathnameSplitArray[1] !== 'embedded-report-summary-front-and-dividing-range'
            && pathnameSplitArray[1] !== 'embedded-report-summary-main-range'
            && pathnameSplitArray[1] !== 'embedded-report-summary-large'
            && pathnameSplitArray[1] !== 'ddddddd')
            ?
            <Layout.Footer style={{ textAlign: 'center', color: "#fff" }}>MSC HQ</Layout.Footer>
            :
            null
        }
        </>
    )
}
export default Footer